<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main">
        <!-- <SubTitleComponent :title="title"></SubTitleComponent> -->
        <div class="box">
          <!-- <div class="filter">
            <el-row :gutter="10">
              <el-col :span="20" class="tag_box">
                <el-tag :class="-1 == styleCur ? 'on' : ''" color="#fff" @click="changeStyle(-1)">全部</el-tag>
                <el-tag v-for="(item, index) in styleData" :key="'style'+index" :class="index == styleCur ? 'on' : ''" color="#fff" @click="changeStyle(index)">{{ item.style_type }}</el-tag>
              </el-col>
              <el-col :span="4"><el-button icon="el-icon-right" type="primary" @click="toNew"><span class="btn">上传新素材</span></el-button></el-col>
            </el-row>
          </div> -->
          <div class="filter">
            <el-row :gutter="10">
              <el-col :span="20">
                <div class="tag">
                  <el-row>
                    <el-col :span="4" style="padding-right:20px">
                      <el-tag type="success" class="label" effect="light">风格</el-tag>
                    </el-col>
                    <el-col :span="20" class="tag_main">
                      <el-tag :type="-1 == styleCur ? 'success' : 'info'" :class="'all_item'" @click="changeStyle(-1)" :effect="'light'">全部</el-tag>
                      <el-tag :type="index == styleCur ? 'success' : 'info'" v-for="(item, index) in styleData" :key="'style'+index" :effect="'light'" @click="changeStyle(index)">{{ item.style_type }}</el-tag>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4" style="padding-right:20px">
                      <el-tag type="success" class="label" effect="light">空间类型</el-tag>
                    </el-col>
                    <el-col :span="20" class="tag_main">
                      <el-tag :type="-1 == spaceCur ? 'success' : 'info'" :class="'all_item'" @click="changeSpace(-1)" :effect="'light'">全部</el-tag>
                      <el-tag :type="index == spaceCur ? 'success' : 'info'" v-for="(item, index) in spaceData" :key="'space'+index" :effect="'light'" @click="changeSpace(index)">{{ item.space_type }}</el-tag>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :span="4"><el-button icon="el-icon-right" type="success" @click="toNew"><span class="btn">上传新素材</span></el-button></el-col>
            </el-row>
          </div>
          <div v-loading="loadType" class="list_box" ref="listBox" v-infinite-scroll="getMeterial">
            <!-- <ul class="list" v-if="meterialData.length > 0" v-infinite-scroll="getMeterial">
              <li v-for="(item, index) in meterialData" :key="'meterial'+index" class="item" @click="toDetail(index)">
                <img :src="item.photo_url + '?x-oss-process=image/resize,m_fill,w_1000,h_1000'" alt="">
                <div class="name"></div>
              </li>
            </ul> -->
            <waterfall :col="5" :gutterWidth="20" :data="meterialData" :lazyDistance="200" @finish="loadFinish">
              <template>
                <div v-for="(item, index) in meterialData" :key="'meterial'+index" class="item" @click="toDetail(index)">
                  <img :src="item.photo_url + '?x-oss-process=image/resize,w_300'" alt="">
                  <!-- <div class="name">{{ index + 1 }}</div> -->
                </div>
              </template>
            </waterfall>
            <div class="list" v-if="meterialData.length <= 0">
              <el-empty description="暂无数据"></el-empty>
            </div>
          </div>
        </div>
        <el-dialog
          v-if="dialogVisible == 'detail'"
          :visible.sync="dialogVisit"
          width="60%"
          :show-close="true"
          center
          :closeDetail="closeDetail">
          <div class="img">
            <img v-if="dialogCur != -1" :src="detailImg" alt="">
          </div>
          <span slot="footer" class="dialog-footer">
            <!-- <el-button @click="toCancel">返回</el-button> -->
            <el-button @click="toGenerate(dialogCur)">生成同款</el-button>
            <el-button type="success" @click="toDelete(dialogCur)"><i class="el-icon-delete"></i> 删除</el-button>
          </span>
        </el-dialog>
        <el-dialog
          v-if="dialogVisible == 'new'"
          :visible.sync="dialogVisit"
          top="10vh"
          width="60%"
          :show-close="true"
          center
          :closeDetail="closeDetail">
          <h3>上传新素材</h3>
          <div class="upload_box">
            <el-upload
              class="upload-demo"
              action=""
              :show-file-list="false"
              multiple
              :http-request="uploadImage">
              <img v-if="uploadImg" :src="uploadImg" class="avatar">
              <el-button v-else class="" icon="el-icon-plus"></el-button>
            </el-upload>
          </div>
          <div class="pop_tag_box">
            <el-row :gutter="10">
              <el-col :span="2">
                <div class="label">风格</div>
              </el-col>
              <el-col :span="22">
                <el-tag
                  :key="item.style_type"
                  v-for="(item, index) in styleData"
                  :closable="item.material_style_id != 0"
                  :disable-transitions="false"
                  :effect="uploadStyleCur == index ? 'dark' : 'plain'"
                  @close="handleClose(index)"
                  @click="uploadStyleClick(index)"
                  type="success">
                  {{item.style_type}}
                </el-tag>
                <el-input
                  class="input-new-tag"
                  v-if="inputStyleVisible"
                  v-model="inputStyleValue"
                  ref="saveStyleTagInput"
                  size="small"
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
                >
                </el-input>
                <el-button v-else class="button-new-tag" size="small" @click="showStyleInput">+ new</el-button>
              </el-col>
            </el-row>
          </div>
          <div class="pop_tag_box">
            <el-row :gutter="10">
              <el-col :span="2">
                <div class="label">空间</div>
              </el-col>
              <el-col :span="22">
                <el-tag
                  v-for="(item, index) in spaceData"
                  :key="item.space_type"
                  :closable="item.material_space_id != 0"
                  :disable-transitions="false"
                  :effect="uploadSpaceCur == index ? 'dark' : 'plain'"
                  @close="handleSpaceClose(index)"
                  @click="uploadSpaceClick(index)"
                  type="success">
                  {{item.space_type}}
                </el-tag>
                <el-input
                  class="input-new-tag"
                  v-if="inputSpaceVisible"
                  v-model="inputSpaceValue"
                  ref="saveSpaceTagInput"
                  size="small"
                  @keyup.enter.native="handleInputSpaceConfirm"
                  @blur="handleInputSpaceConfirm"
                >
                </el-input>
                <el-button v-else class="button-new-tag" size="small" @click="showSpaceInput">+ new</el-button>
              </el-col>
            </el-row>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="toCancel">取消</el-button>
            <el-button type="success" @click="toSave">开始上传</el-button>
          </span>
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>
  
<script>

let _ajaxType = 0
let styleType = 0

const style_data = [
  {
    "material_style_id": 0,
    "style_type": "现代"
  },
  {
    "material_style_id": 0,
    "style_type": "简约"
  },
  {
    "material_style_id": 0,
    "style_type": "奢华"
  },
  {
    "material_style_id": 0,
    "style_type": "新中式"
  },
  {
    "material_style_id": 0,
    "style_type": "北欧"
  },
  {
    "material_style_id": 0,
    "style_type": "工业风"
  },
  {
    "material_style_id": 0,
    "style_type": "复古"
  },
  {
    "material_style_id": 2,
    "style_type": "抽象"
  }
]

const meterial_data = [
  {
    "material_id": 2,
    "photo_url": "https://ylww.oss-cn-shenzhen.aliyuncs.com/attachment/20250519/202505191439123531.jpg",
    "style_type": "北欧",
    "space_type": "展厅"
  },
  {
    "material_id": 1,
    "photo_url": "https://ylww.oss-cn-shenzhen.aliyuncs.com/attachment/20250519/202505191439123531.jpg",
    "style_type": "现代",
    "space_type": "展厅"
  }
]

export default {
  name: 'Material',
  components: {},
  data() {
    return {
      title: '个人素材库',
      searchInput: '',
      styleData: [],
      styleCur: -1,
      spaceData: [],
      spaceCur: -1,
      uploadStyleCur: 0,
      uploadSpaceCur: 0,
      meterialData: [],
      dialogVisible: '',
      dialogVisit: true,
      dialogCur: -1,
      page: 0,
      pagesize: 100,
      allpage: 0,
      inputStyleVisible: false,
      inputStyleValue: '',
      inputSpaceVisible: false,
      inputSpaceValue: '',
      uploadImg: '',
      listTop: '',
      detailImg: '',
      loadType: true
    }
  },
  mounted() {
    _ajaxType = 0
    this.getData()
  },
  methods: {
    load () {
      // 
    },
    getData() {
      // this.styleData = style_data
      // this.spaceData = space_data
      // this.meterialData = meterial_data
      this.getStyle()
      // setTimeout(this.getMeterial, 500)
    },
    getStyle() {
      let _url = "/api/?mod=material_style"
      this.axios.post(_url).then(json => {
        // 获取
        let _data = json.data.data
        console.log("styleData", _data);
        if (json.data.errcode == 0) {
          this.styleData = _data.result
          // styleType = 1
          this.getSpace()
        }
        console.log(json.data);
      })
    },
    getSpace() {
      let _url = "/api/?mod=material_space"
      this.axios.post(_url).then(json => {
        // 获取
        let _data = json.data.data
        console.log("spaceData", _data);
        if (json.data.errcode == 0) {
          this.spaceData = _data.result
          // spaceType = 1
          this.getMeterial()
        }
        console.log(json.data);
      })
    },
    getMeterial() {
      // if(styleType != 1){
      //   setTimeout(this.getMeterial, 500)
      //   return
      // }
      if(_ajaxType == 1) return
      let _page = this.page
      let _allpage = this.allpage
      console.log(_page, _allpage)
      if(_allpage <= 0 || _page < _allpage){
        _ajaxType = 1
        let _url = "/api/?mod=material"
        let _style = ''
        let _space = ''
        if(this.styleCur != -1){
          _style = this.styleData[this.styleCur].style_type
        }
        if(this.spaceCur != -1){
          _space = this.spaceData[this.spaceCur].space_type
        }
        let _clientData = {
          page: _page + 1,
          pagesize: this.pagesize,
          type: 1,
          style_type: _style,
          space_type: _space
        }
        this.axios.post(_url, _clientData).then(json => {
          // 获取
          _ajaxType = 0
          let _data = json.data.data
          console.log("materialData", _data);
          if (json.data.errcode == 0) {
            this.page = _data.page
            this.allpage = _data.allpage
            this.meterialData = [...this.meterialData, ..._data.result]
            // this.getHeight()
          }
          console.log(json.data);
        })
      }
    },
    getHeight() {
      let _listbox = this.$refs.listBox
      console.log('listbox', _listbox)
      console.log('listbox', _listbox.offsetTop)
      this.listTop = window.innerHeight - _listbox.offsetTop - 30
      console.log('listbox', _listbox.scrollHeight)
    },
    closeDetail(e) {
      this.detailImg = ''
      this.dialogCur = -1
      this.dialogVisit = false
      this.dialogVisible = ''
      e()
    },
    toDetail(cur) {
      this.detailImg = this.meterialData[cur].photo_url
      this.dialogCur = cur
      this.dialogVisit = true
      this.dialogVisible = 'detail'
    },
    toGenerate(cur) {
      console.log(cur)
      let _material = this.meterialData[cur]
      let _photo = _material.photo_url
      let _style = _material.style_type
      let _space = _material.space_type
      localStorage.setItem('material_url', _photo)
      localStorage.setItem('material_style', _style)
      localStorage.setItem('material_space', _space)
      this.$router.push({ path: '/effectsave' })
    },
    toNew() {
      this.dialogVisible = 'new'
      this.dialogVisit = true
    },
    toCancel() {
      this.dialogCur = -1
      this.dialogVisit = false
      this.dialogVisible = ''
    },
    handleClose(cur) {
      if(_ajaxType == 1) return
      _ajaxType = 1
      this.$confirm('删除风格标签会将该标签下的所有素材一并删除，请确认是否删除该标签!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _url = "/api/?mod=material_style&action=delete"
        let _id = this.styleData[cur].material_style_id
        let _deleteData = {
          material_style_id: _id
        }
        this.axios.post(_url, _deleteData).then(json => {
          // 获取
          _ajaxType = 0
          let _data = json.data.data
          console.log("deleteData", _data);
          if (json.data.errcode == 0) {
            let _styleData = [...this.styleData]
            _styleData.splice(cur, 1)
            this.styleData = _styleData
            // styleType = 1
          }
          console.log(json.data);
        })
      }).catch(() => {
        _ajaxType = 0 
      });
    },
    handleSpaceClose(cur) {
      if(_ajaxType == 1) return
      _ajaxType = 1
      this.$confirm('删除空间类型会将该类型下的所有素材一并删除，请确认是否删除该类型!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _url = "/api/?mod=material_space&action=delete"
        let _id = this.spaceData[cur].material_space_id
        let _deleteData = {
          material_space_id: _id
        }
        this.axios.post(_url, _deleteData).then(json => {
          // 获取
          _ajaxType = 0
          let _data = json.data.data
          console.log("deleteData", _data);
          if (json.data.errcode == 0) {
            let _spaceData = [...this.spaceData]
            _spaceData.splice(cur, 1)
            this.spaceData = _spaceData
            // styleType = 1
          }
          console.log(json.data);
        })
      }).catch(() => {
        _ajaxType = 0 
      });
    },
    uploadStyleClick(cur){
      this.uploadStyleCur = cur
    },
    uploadSpaceClick(cur){
      this.uploadSpaceCur = cur
    },
    showStyleInput() {
      this.inputStyleVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveStyleTagInput.$refs.input.focus();
      });
    },
    showSpaceInput() {
      this.inputSpaceVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveSpaceTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        let _url = "/api/?mod=material_style&action=save"
        let _saveData = {
          style_type: inputValue
        }
        this.axios.post(_url, _saveData).then(json => {
          // 获取
          let _data = json.data.data
          console.log("saveData", _data);
          if (json.data.errcode == 0) {
            this.styleData.push({
              style_type: inputValue, 
              material_style_id: _data.material_style_id
            })
            // styleType = 1
          }
          console.log(json.data);
        })
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    handleInputSpaceConfirm() {
      let inputSpaceValue = this.inputSpaceValue;
      if (inputSpaceValue) {
        let _url = "/api/?mod=material_space&action=save"
        let _saveData = {
          space_type: inputSpaceValue
        }
        this.axios.post(_url, _saveData).then(json => {
          // 获取
          let _data = json.data.data
          console.log("saveData", _data);
          if (json.data.errcode == 0) {
            this.spaceData.push({
              space_type: inputSpaceValue, 
              material_space_id: _data.material_space_id
            })
            // spaceType = 1
          }
          console.log(json.data);
        })
      }
      this.inputSpaceVisible = false;
      this.inputSpaceValue = '';
    },
    uploadImage(image) {
      console.log("1", image);
      if(_ajaxType == 1) return
      _ajaxType = 1
      return new Promise((resolve, reject) => {
        // console.log('2',image.file)
        const isImage = image.file.type.startsWith('image/');
        if (!isImage) {
          this.uploadError = '只能上传图片文件';
          _ajaxType = 0
          reject(new Error('只能上传图片文件'));
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          console.log('upload',e)
          const base64Data = e.target.result;
          this.toUpload(base64Data);
          resolve(false); // 阻止默认上传行为
        };
        reader.onerror = (error) => {
          console.error('读取文件失败:', error);
          this.uploadError = '读取文件失败，请重试';
          reject(error);
        };
        reader.readAsDataURL(image.file);
      });
    },
    toUpload(base64Data) {
      let _url = "/api/?mod=upload"
      let _uploadData = {
        photo: base64Data
      }
      console.log(_uploadData)
      this.axios.post(_url, _uploadData).then(json => {
        _ajaxType = 0
        let _data = json.data.data
        console.log("uploadData", _data);
        if (json.data.errcode == 0) {
          this.uploadImg = _data.photo_url
        }
        console.log(json.data);
      })
    },
    toSave() {
      if(_ajaxType == 1) return
      _ajaxType = 1
      let _url = "/api/?mod=material&action=save"
      let _style = this.styleData[this.uploadStyleCur].style_type
      let _uploadData = {
        photo_url: this.uploadImg,
        style_type: _style,
        space_type: this.spaceData[this.uploadSpaceCur].space_type
      }
      this.axios.post(_url, _uploadData).then(json => {
        // 获取
        let _this = this
        _ajaxType = 0
        let _data = json.data.data
        console.log("uploadData", _data);
        if (json.data.errcode == 0) {
          this.$message({
            message: '上传成功',
            type: 'success',
            offset: 300,
            duration: 500,
            onClose: function() {
              _this.uploadImg = ''
              _this.dialogVisible = ''
              _this.styleCur = _this.uploadStyleCur
              _this.spaceCur = _this.uploadSpaceCur
              _this.page = 0
              _this.allpage = 0
              _this.meterialData = []
              _this.getStyle()
            }
          });
        }
        console.log(json.data);
      })
    },
    toDelete(cur) {
      console.log(cur)
      if(_ajaxType == 1) return
      _ajaxType = 1
      this.$confirm('请确认是否删除该素材!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _url = "/api/?mod=material&action=delete"
        let _id = this.meterialData[this.dialogCur].material_id
        let _uploadData = {
          material_id: _id
        }
        this.axios.post(_url, _uploadData).then(json => {
          // 获取
          let _this = this
          _ajaxType = 0
          let _data = json.data.data
          console.log("deleteData", _data);
          if (json.data.errcode == 0) {
            this.$message({
              message: '删除成功',
              type: 'success',
              offset: 300,
              onClose: function() {
                _this.dialogVisible = ''
                _this.dialogCur = -1
                _this.styleCur = _this.uploadStyleCur
                _this.page = 0
                _this.allpage = 0
                _this.meterialData = []
                _this.getStyle()
              }
            });
          }
          console.log(json.data);
        })
      }).catch(() => {
        _ajaxType = 0 
      });
    },
    changeStyle(cur) {
      this.styleCur = cur
      this.page = 0
      this.allpage = 0
      this.meterialData = []
      this.loadType = true
      this.getMeterial()
    },
    changeSpace(cur) {
      this.spaceCur = cur
      this.page = 0
      this.allpage = 0
      this.meterialData = []
      this.loadType = true
      this.getMeterial()
    },
    loadFinish() {
      console.log('loadFinish')
      this.loadType = false
    }
  }
}
</script>
  
<style scoped lang="less">
.header {
  z-index: 1001;
}
.main {
  padding-top: 10px;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 6px;
  .box {
    min-height: calc(100vh - 154px);
    padding: 20px;
    // background: #fff;
    box-sizing: border-box;
    .filter {
      margin-bottom: 20px;
      padding: 10px;
      background: #fff;
      h4 {
        // margin-bottom: 8px;
        // padding-left: 12px;
        background: #fff;
        color: rgb(16, 16, 16);
        font-size: 20px;
        font-weight: 400;
        line-height: 2em;
      }
      .tag_box {
        font-size: 0;
      }
      .el-button {
        width: 100%;
      }
    }
    .tag {
      padding: 10px;
      background: #fff;
    }
    .tag_main {
      // position: relative;
      // padding-left: 90px;
      .all_item {
        // position: absolute;
        // top: 0;
        // left: 0;
      }
      .tag_box {
        display: inline-block;
      }
    }
    .el-tag {
      margin: 0 16px 16px 0;
      // padding: 0 20px;
      // border: 0;
      // color: rgba(10,10,10,1);
      height: 30px;
      font-size: 18px;
      line-height: 30px;
      border: 0;
      &.el-tag--info {
        background: transparent;
      }
      &.label {
        width: 100%;
        text-align: center;
        // font-size: 24px;
        // font-weight: 700;
      }
      &.on {
        // font-size: 24px;
        // font-weight: 700;
      }
    }
    .list_box {
      // height: 100%;
      overflow: auto;
      scrollbar-width: none;
      -ms-overflow-style: none;
      .item {
        position: relative;
        // flex: 0 0 calc(30%);
        gap: 20px;
        margin-bottom: 20px;
        // padding: 10px;
        // background: #fff;
        // border: 1px dashed rgb(187, 187, 187);
        border-radius: 5px;
        box-sizing: border-box;
        font-size: 0;
        img {
          width: 100%;
          aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
          object-fit: cover;
          border-radius: 4px;
        }
      }
    }
    ul.list {
      // margin-top: 20px;
      display: grid;
      // flex-wrap: wrap;
      // justify-content: space-between;
      grid-template-columns: repeat(5, 1fr);
      padding-inline-start: 0;
      gap: 20px;
      // padding: 0 30px;
      vertical-align: top;
      list-style: none;
      li {
        position: relative;
        // flex: 0 0 calc(30%);
        gap: 20px;
        padding: 10px;
        background: #fff;
        // border: 1px dashed rgb(187, 187, 187);
        border-radius: 5px;
        box-sizing: border-box;
        font-size: 0;
        img {
          width: 100%;
          aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
          object-fit: cover;
        }
      }
    }
  }
  h3 {
    font-size: 30px;
    text-align: center;
  }
  .upload_box {
    width: 200px;
    margin: 20px auto 0;
    .el-button {
      width: 100%;
      aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
    }
    img {
      width: 100%;
      aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
      object-fit: cover;
    }
  }
  .pop_tag_box {
    margin-top: 30px;
    font-size: 0;
    .label {
      font-size: 14px;
      line-height: 30px;
    }
    .el-tag {
      margin: 0 0 10px 10px;
    }
    .el-button {
      margin: 0 0 10px 10px;
    }
    .el-input {
      display: inline-block;
      width: 100px;
      margin: 0 0 10px 10px;
    }
  }
}
.el-dialog {
  .img {
    text-align: center;
    img {
      max-width: 100%;
      max-height: 60vh;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Material/Person.vue